module.exports = {"652328100":"木垒镇","652328101":"西吉尔镇","652328102":"东城镇","652328103":"新户镇","652328200":"英格堡乡","652328201":"照壁山乡","652328203":"雀仁乡","652328204":"白杨河乡","652328205":"大石头乡","652328206":"大南沟乌孜别克乡","652328207":"博斯坦乡","652328401":"克热克库都克牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652328.json
// module id = 3077
// module chunks = 0